import { JOUR } from '@/configuration/devisConf';
import genererGuid from '@/services/general/genererGuid';
import getDateDebutFinEchances from '@/services/commande/echeancierFacturation/getDateDebutFinEchances';
import { genererLigneEcheancierForAuto } from '@/services/commande/echeancierFacturation/genererLigneEcheancier';

export default function genererEcheancierAuto(
  lignesCommandes, datePremierAffichage, dateCommande,
) {
  return {
    openEcheancierLignes: false,
    echeancierLignes: [genererLigneEcheancierForAuto()],
    dateDebut: getDateDebutFinEchances(lignesCommandes, datePremierAffichage, dateCommande),
    dateFin: getDateDebutFinEchances(lignesCommandes, datePremierAffichage, dateCommande),
    dateFinPremiereEcheance: getDateDebutFinEchances(
      lignesCommandes, datePremierAffichage, dateCommande,
    ),
    quantitePeriodicite: 0,
    unitePeriodicitie: JOUR,
    referenceEcheancier: genererGuid(),
    select: false,
  };
}
